









import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MapObject } from '@/core/components/networkViewer/types';
import { Formatters } from '@/core/components/networkViewer/formatters';
import { LogisticsNetwork } from '@/dto/';
@Component
export default class SVGRect extends Vue {
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: false }) public item!: MapObject;
    @Prop({ type: Number, required: true }) public dataToShow!: number;
    @Prop({ type: Boolean, required: true }) public showAdditionalLabel!: boolean;
    @Prop({ type: Number, required: true }) public y!: number;
    @Prop({ type: Number, required: true }) public height!: number;

    public show: boolean = false;
    public width: number = 0;

    private get showData(): boolean {
        if (this.dataToShow === 1) {
            return this.item.name !== null;
        } else if (this.dataToShow === 2) {
            if (this.showAdditionalLabel && (this.item.additionalLabel !== null
                && this.item.additionalLabel !== undefined)) {
                return true;
            } else {
                return false;
            }
        }

        return false;
    }

    private get calculateWidth(): number {
        let result = Formatters.prototype.norm_square(this.item?.capacity ?? 0,
                                                      0,
                                                      this.network.state.mapObjects.maxCapacity ?? 0,
                                                      this.network.preferences.mapObject.minDisplayCapacityRadius,
                                                      this.network.preferences.mapObject.maxDisplayCapacityRadius);
        result = Formatters.prototype.add(result, 8);
        result = Formatters.prototype.max(result, this.network.preferences.mapObject.minDisplayCapacityRadius);
        result = Formatters.prototype.ifNaN(result, 0);
        return Formatters.prototype.add(result, 12);
    }

    private get calculateX(): number {
        if (this.dataToShow === 1) {
            return 0;
        } else {
            let result = Formatters.prototype.norm_square(this.item?.capacity ?? 0,
                                                        0,
                                                        (this.network.state.mapObjects.maxCapacity ?? 0),
                                                        this.network.preferences.mapObject.minDisplayCapacityRadius,
                                                        this.network.preferences.mapObject.maxDisplayCapacityRadius);
            result = Formatters.prototype.max(result, this.network.preferences.mapObject.minDisplayCapacityRadius);
            result = Formatters.prototype.ifNaN(result, 0);
            result = Formatters.prototype.invert(result);
            return result;
        }
    }
}
